import { ReduxService } from 'dashboard-services/services';

import { basicAIParserActions } from 'actions/modules/aiTools';

export const aiParserInitialState = {
  expectedOutputFile: undefined, // not in common state as expected output is not common case
  expectedOutputFileRaw: undefined,
  expectedOutputFileInfo: undefined,
}

export default (state = aiParserInitialState, action) => {
  switch (action.type) {
    case basicAIParserActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case basicAIParserActions.ADD_TO_VERSIONS:
      return ReduxService.updateObject(state, { versions: state.versions.add(action.item) })
    case basicAIParserActions.CLEAR:
      return aiParserInitialState;
    default:
      return state;
  }
}